import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import TagManager from 'react-gtm-module';
import './api/axiosConfig'; // Configure axios interceptors

const tagManagerArgs = {
    gtmId:'GTM-W7KTNMDS'
}
TagManager.initialize(tagManagerArgs);

// Proactively unregister any previously installed service workers and clear caches.
// This mitigates production-only caching issues from older deployments.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
            try { registration.unregister(); } catch (e) { /* noop */ }
        });
    }).catch(() => {});

    if (window.caches && typeof window.caches.keys === 'function') {
        window.caches.keys().then((keys) => {
            keys.forEach((key) => {
                try { window.caches.delete(key); } catch (e) { /* noop */ }
            });
        }).catch(() => {});
    }
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
